export enum OfferStatusCodesEnum {
  PUBLISHED = 'published',
  TESTY = 'TESTY',
  NEW = 'new',
  INTRODUCED = 'WPROWADZANA',
  WITHDRAWN = 'withdrawn'
}



// WEBPACK FOOTER //
// ./src/app/enums/offerStatusCodes.enum.ts